import React from 'react'
import { getDocumentFileUrl } from '../../services/ocr-api'

interface Props {
  documentId: string
  mimeType: string
}

const DocumentViewer: React.FC<Props> = ({ documentId, mimeType }) => {
  const url = getDocumentFileUrl(documentId)
  const isPdf = mimeType === 'application/pdf'

  return (
    <div style={{ height: '100%', borderRadius: '8px', overflow: 'hidden' }}>
      {isPdf ? (
        <iframe
          src={url}
          width="100%"
          height="100%"
          title="Document Preview"
          style={{ border: 'none' }}
        />
      ) : (
        <img
          src={url}
          alt="Document Preview"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      )}
    </div>
  )
}

export default DocumentViewer
